export default "__VITE_PUBLIC_ASSET__b6135679__"